import React, { useContext, useEffect, useState, useRef } from "react";
import { Button, Pagination } from "antd";
import "./Home.css";
import {
  CARD_GRID_COLUMN_GAP,
  CARD_GRID_PERCENTAGE,
  CARD_GRID_ROW_GAP,
  CARD_WIDTH,
} from "../../config/layoutConfig";
// import { globalFilter } from "./Filter";
import useWindowSize from "../../library/hooks/useWindowSize";
import AHPVillagesBanner from "./components/AHPVillagesBanner/AHPVillagesBanner";
import HomeFilter from "./HomeFilter";
import { ENTITIES } from "../../entities/entitiesConfig";
import SuggestionsGrid from "./components/SuggestionsGrid";
import { useLocation } from "react-router";
import { AppContext } from "../../context";
import ProductGrid from "./ProductGrid";
import StoreGrid from "./StoreGrid";
import { useLanguage } from "../../hooks/useLanguage";
import Awards from "../../components/Awards/Awards";
import "../../assets/css/fonts.css";
import Sustainability from "../../components/Sustainability/Sustainability";
import { openkit } from "../../library/database";
import Modal from "antd/lib/modal/Modal";
import { AiOutlineMail } from "react-icons/ai";
import LoginModal from "../User/LoginModal";

function Home({ match, history }) {
  const info = useContext(AppContext);
  const [stores, setStores] = useState([]);
  const [products, setProducts] = useState([]);
  const [page, setPage] = useState(1);
  const [openFilter, setOpenFilter] = useState(false);
  const [isWelcomeDialogVisible, setIsWelcomeDialogVisible] = useState(false);
  const [innerWidth, setInnerWidth] = useState(null);
  const [isLoginModalVisible, setIsLoginModalVisible] = useState(false);
  const location = useLocation();

  // layout dimensions
  const [layoutDim, setLayoutDim] = useState({});

  const { width, height } = useWindowSize();

  const handleOk = () => {
    setIsWelcomeDialogVisible(false);
  };

  useEffect(() => {
    (async () => {
      const params = new URLSearchParams(location.search);
      const confirmationId = params.get("confirm-email");
      if (confirmationId) {
        const user = await openkit.users.confirmEmail(confirmationId);
        if (user?.token) {
          window.localStorage.setItem("openkit", user.token);

          if (user) {
            info.setUser(user);
            setIsWelcomeDialogVisible(true);
          }
        }

        return;
      }
    })();
  }, []);

  useEffect(() => {
    (async () => {
      // from password reset
      const params = new URLSearchParams(location.search);
      const passwordResetId = params.get("password-reset");
      if (passwordResetId) {
        info.setResetPasswordId(passwordResetId);
        setIsLoginModalVisible(true);
        // const user = await openkit.users.confirmEmail(passwordResetId);
        // if (user?.token) {
        //   window.localStorage.setItem("openkit", user.token);

        //   if (user) {
        //     info.setUser(user);
        //     setIsWelcomeDialogVisible(true);
        //   }
        // }

        return;
      }
    })();
  }, []);

  // useLanguage(history, info);
  useEffect(() => {
    let language = history.location.pathname.substring(1, 3);

    const languages = ["pt", "en", "fr", "es", "de", "it"];

    if (languages.includes(language)) info.setLanguage(language);
    else info.setLanguage("pt");
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const typeFromURLParam = params.get("serv");
    if (typeFromURLParam) {
      info.setType(typeFromURLParam);
      setOpenFilter(true);
    }
  }, []);

  useEffect(() => {
    if (info.type) {
      const languagePath = info.language === "pt" ? "" : info.language + "/";
      history.push({
        pathname: "/" + languagePath,
        search: "?serv=" + info.type,
      });
    }
  }, [info.type]);

  useEffect(() => {
    // calculate dimensions and number of cards to display
    // total width = width
    // width of the card grid container
    const cardGridContainerWidth = CARD_GRID_PERCENTAGE * width;
    // calculate number of cards that fit a row (the minimum is 1)
    const cardsPerRow =
      Math.floor(
        (cardGridContainerWidth - CARD_GRID_ROW_GAP) /
          (CARD_WIDTH + CARD_GRID_ROW_GAP)
      ) || 1;

    setLayoutDim({ ...layoutDim, cardGridContainerWidth, cardsPerRow });
  }, [width]);

  useEffect(() => {
    // calculate innerWidth
    let items = [];
    ENTITIES[info?.type]?.typeOfList === "store" && (items = stores);
    ENTITIES[info?.type]?.typeOfList === "product" && (items = products);
    items?.length &&
      setInnerWidth(
        items.length < layoutDim.cardsPerRow
          ? items.length * (CARD_WIDTH + CARD_GRID_COLUMN_GAP) +
              CARD_GRID_COLUMN_GAP +
              "px"
          : layoutDim.cardsPerRow * (CARD_WIDTH + CARD_GRID_COLUMN_GAP) +
              CARD_GRID_COLUMN_GAP +
              "px"
      );
  }, [stores, products, width]);

  return (
    <div className="ahp-hero">
      <HomeFilter
        setOpenFilter={setOpenFilter}
        setProducts={setProducts}
        setStores={setStores}
        page={page}
      />
      {!openFilter && <AHPVillagesBanner openFilter={openFilter} />}
      {ENTITIES[info?.type]?.typeOfList === "store" &&
        (info?.type || info.villages.length > 0 || info.name) && (
          <>
            <StoreGrid stores={stores} innerWidth={innerWidth} />
            {stores?.length > 0 && stores[0].count / info.pageSize > 1 && (
              <div className="ahp-main-filter-pagination">
                <Pagination
                  onChange={(page, pageSize) => {
                    setPage(page);
                    info.setPageSize(pageSize);
                  }}
                  total={stores.length && stores[0].count}
                  current={page}
                  pageSize={info.pageSize}
                />
              </div>
            )}
          </>
        )}
      {ENTITIES[info?.type]?.typeOfList === "product" && (
        <>
          {/* if store is urban mobility, show Sustainability since there are no store card where to show it  */}
          {stores[0]?.type === "rentacar" && stores[0]?.ods && (
            <div style={{ maxWidth: "60%", margin: "0 auto" }}>
              <Sustainability
                sustainability={stores[0].ods}
                lang="PT"
                iconWidth={80}
                centerTitle={true}
              />
            </div>
          )}

          <ProductGrid
            products={products}
            entity={info?.type}
            innerWidth={innerWidth}
          />
          {products?.length > 0 && products[0].count / info.pageSize > 1 && (
            <div className="ahp-main-filter-pagination">
              <Pagination
                onChange={(page, pageSize) => setPage(page)}
                total={products.length && products[0].count}
                current={page}
                pageSize={info.pageSize}
              />
            </div>
          )}
        </>
      )}
      <SuggestionsGrid
        type={info?.type}
        villages={info.villages}
        layoutDim={layoutDim}
      />
      {/* {!openFilter && <Awards transparent={false} />} */}
      <Modal
        title={null}
        visible={isWelcomeDialogVisible}
        footer={[
          <div style={{ textAlign: "center" }}>
            <Button key="ok" onClick={handleOk}>
              OK
            </Button>
          </div>,
        ]}
        // title={null}
        width="auto"
        style={{ maxWidth: "400px", height: "300px" }}
        closable={false}
      >
        <div className="ahp-header" style={{ marginTop: -20 }}>
          <img
            src="https://aldeiashistoricasdeportugal.com/wp-content/uploads/2018/11/logo.png"
            alt="aldeias historicas logo"
          />
        </div>
        <div
          className="ahp-img-background"
          style={{
            backgroundImage:
              "url('https://aldeiashistoricasdeportugal.com/wp-content/uploads/2018/12/AH-Idanha-a-Velha-1.jpg'",
          }}
        ></div>
        <div style={{ fontSize: 16, textAlign: "center", paddingTop: 20 }}>
          {info.t("welcomToAldeias")}
        </div>
        <div style={{ fontSize: 16, textAlign: "center", paddingBottom: 20 }}>
          {info.t("youCanNowReserve")}
        </div>
        <div
          style={{
            display: "flex",
            fontSize: 16,
            alignItems: "center",
            justifyContent: "center",
            gap: 10,
          }}
        >
          <AiOutlineMail /> {info?.user?.email}
        </div>
      </Modal>
      <LoginModal
        isModalVisible={isLoginModalVisible}
        setIsModalVisible={setIsLoginModalVisible}
        initialState="newPassword"
      />
    </div>
  );
}

export default React.memo(Home);
